/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

class Bundle {
  static bundle: any = {};
  static setValue(pKey: string, pValor: any) {
    if (this.bundle === undefined) {
      this.bundle = {};
    }
    this.bundle[pKey] = pValor;
  }

  static getValue(pKey: string) {
    return this.bundle[pKey];
  }

  static cleanValues() {
    this.bundle = {};
  }
  static clearValue(pKey: string) {
    if (this.bundle[pKey]) {
      this.bundle[pKey] = null;
    }
  }
  static accumulate(pKey: string, pValor: any) {
    if (this.bundle === undefined) {
      this.bundle = {};
    }
    if (this.bundle[pKey] === undefined || this.bundle[pKey] === null) {
      this.bundle[pKey] = [];
    }
    this.bundle[pKey].push(pValor);
  }
}

export default Bundle;
